import Head from "next/head";
import { useRouter } from "next/router";
import * as FormData from "form-data";
import {authHeader} from '../../../../_helpers'
import { Col, Container, Row, Card } from "react-bootstrap";
import MultiStepProductForm from "../../../../components/MultiStepProductForm";
import InnerLayout from "../../../../components/InnerPageLayout";
import CategoryLinks from "../../../../components/CategoryLinks";
import RelatedProducts from "../../../../components/RelatedProducts";
import CustomizedAccordions from "../../../../components/accordion";
import ProductImage from "../../../../components/ProductImage";

function brand({
  seo_title,
  meta_description,
  meta_keywords,
  content,
  name,
  images,
  deviceType,
  relatedProducts,
  faqs,
  max_amount,
  product,
  category_id,
  options,
  brand_options,
  max_page,
  page_heading,
}) {
  const router = useRouter();
  const productSlug = router.query.product;
  const brand = router.query.brand;
  const ldjson = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => {
      return {
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      };
    }),
  };
  return (
    <>
      <Head>
        <title>{seo_title}</title>
        <meta name="description" content={meta_description} />
        <meta name="Keywords" content={meta_keywords} />
        <link
          rel="canonical"
          href={`/sell-used-tablets/${brand}/${productSlug}`}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(ldjson) }}
        />
      </Head>
      <InnerLayout innerPage={true} deviceType={deviceType}>
        <Container fluid>
          <Row>
            <Col lg={5}>
              <ProductImage
                name={name}
                images={images}
                max_amount={max_amount}
              />
            </Col>
            <Col lg={7}>
              <MultiStepProductForm
                product={product}
                category_id={category_id}
                options={options}
                brand_options={brand_options}
                max_page={max_page}
                page_heading={page_heading}
              />
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row className="justified-content-center">
            <Col>
              {!!content && content.lenght > 10 && (
                <Card>
                  <Card.Body>
                    <Card.Text
                      as={"div"}
                      dangerouslySetInnerHTML={{
                        __html: content,
                      }}
                    ></Card.Text>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
          <Row className="justified-content-center mt-2">
            <Col>
              <Card>
                <Card.Body>
                  <Card.Title>FAQ</Card.Title>
                  <CustomizedAccordions faqs={faqs} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        <CategoryLinks />
        {relatedProducts ? (
          <RelatedProducts relatedProducts={relatedProducts} />
        ) : (
          ""
        )}
      </InnerLayout>
    </>
  );
}

export async function getServerSideProps(context) {
  const { brand, product } = context.params;
  var formData = new FormData();
  formData.append("prodSlug", product);
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData,
  };
  const apiUrl = `${process.env.NEXT_PUBLIC_API_URL}products/productDetails`;

  // Fetch data from external API
  const res = await fetch(apiUrl, requestOptions);
  if (!res.ok) {
    return {
      redirect: {
        permanent: false,
        destination: `/sell-used-tablets/${brand}`,
      },
    };
  }
  const data = await res.json();

  // Detect device type in server side
  const UA = context.req.headers["user-agent"];
  const isMobile = Boolean(
    UA.match(/Android|BlackBerry|iPhone|Opera Mini|IEMobile|WPDesktop/i)
  );
  // Pass data to the page via props
  return {
    props: {
      seo_title: data.seo_title ? data.seo_title : product,
      meta_description: data.meta_description ? data.meta_description : "",
      meta_keywords: data.meta_keywords ? data.meta_keywords : "",
      content: data.product ? data.product.description : "",
      name: data.product ? data.product.name : "",
      images: data.product ? data.product.images : "",
      relatedProducts: data.related_products ? data.related_products : "",
      deviceType: isMobile ? "mobile" : "desktop",
      faqs: data.faqs ? data.faqs : "",
      max_amount: data.max_price ? data.max_price : 0,
      product: data.product ? data.product : [],
      category_id: data.category_id ? data.category_id : "",
      options: data.options ? data.options : [],
      brand_options: data.brand_options ? data.brand_options : [],
      max_page: data.max_page ? data.max_page : "",
      page_heading: data.page_heading ? data.page_heading : [],
    },
  };
}

export default brand;